import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Add as AddIcon, Schedule as ScheduleIcon } from '@mui/icons-material';

const ScheduleHeader = ({ onAddClick }) => {
  return (
    <Box className='flex items-center justify-between mb-4 flex-wrap gap-2'>
      <Box className='flex items-center gap-2 flex-wrap '>
        <Box className='size-8 bg-indigo-500 rounded-lg flex items-center justify-center'>
          <ScheduleIcon className='text-white size-5' />
        </Box>
        <Typography variant='h6' className='text-indigo-700 font-semibold'>
          Examination Schedule Management
        </Typography>
      </Box>
      <Box className='flex gap-2'>
        <Button
          variant='contained'
          startIcon={<AddIcon />}
          onClick={onAddClick}
          size='small'
        >
          Schedule Exam
        </Button>
      </Box>
    </Box>
  );
};

export default ScheduleHeader;
